import { render } from "./Head.vue?vue&type=template&id=8ac11978&scoped=true&ts=true"
import script from "./Head.vue?vue&type=script&lang=ts"
export * from "./Head.vue?vue&type=script&lang=ts"

import "./Head.vue?vue&type=style&index=0&id=8ac11978&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/production-Q-saas-plat-manage-vue/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ac11978"]])

export default __exports__